import { ProductClassification } from 'enums';
import { Constants } from 'global';
import { currencyFormatter, productFormatter } from 'utils';

export type ApplicableProduct =
  | ProductClassification.ZipMoney
  | ProductClassification.ZipPay
  | ProductClassification.ZipPlus;

export interface ProductDebrief {
  MenuTitle: string;
  MenuSubtitle: string;
  IntroductionTitle: string;
  CreditLimit: string;
  Explanation: string[];
  TermsConditions: string;
}

export const ProductDetails = new Map<ApplicableProduct, ProductDebrief>([
  [
    ProductClassification.ZipMoney,
    {
      MenuTitle: productFormatter(ProductClassification.ZipMoney),
      MenuSubtitle: 'Bigger purchases',
      IntroductionTitle: "For life's bigger purchases",
      CreditLimit: `Up to ${currencyFormatter(Constants.productDefaults['Zip Money'].TransactionLimit, false)} credit`,
      Explanation: [
        'Interest free from up to 3 months and 5 years',
        'Flexible repayments starting from $50/month',
        `Variable interest rate of ${Constants.productDefaults['Zip Money'].interestRate.percent}% p.a. if you need more time to pay outside the interest free period`,
      ],
      TermsConditions: 'https://zip.co/au/zip-money',
    },
  ],

  [
    ProductClassification.ZipPay,
    {
      MenuTitle: productFormatter(ProductClassification.ZipPay),
      MenuSubtitle: 'Everyday account',
      IntroductionTitle: 'For everyday spend',
      CreditLimit: 'Up to $1,500 credit',
      Explanation: [
        'Interest free, always',
        'Customers can spend everywhere Visa is accepted with the Zip Pay Visa card or directly at partnered merchants',
        'Flexible repayments starting from $10/week',
      ],
      TermsConditions: 'https://zip.co/au/zip-pay',
    },
  ],

  [
    ProductClassification.ZipPlus,
    {
      MenuTitle: productFormatter(ProductClassification.ZipPlus),
      MenuSubtitle: 'Everyday, plus more',
      IntroductionTitle: 'For everyday, plus more',
      CreditLimit: `Up to ${currencyFormatter(Constants.productDefaults['Zip Plus'].TransactionLimit, false)} credit`,
      Explanation: [
        `Interest free when your end of month balance is under ${currencyFormatter(Constants.productDefaults['Zip Plus'].interestFreeThreshold, false)}`,
        `${Constants.productDefaults['Zip Plus'].interestRate.percent}% p.a. when a customer's owing balance at the end of each month is over ${currencyFormatter(Constants.productDefaults['Zip Plus'].interestFreeThreshold, false)}`,
        'Customers can spend everywhere Visa is accepted with the Zip Plus Visa card or directly at partnered merchants',
        'Flexible repayments starting from $20/week',
      ],
      TermsConditions: 'https://zip.co/au/zip-plus',
    },
  ],
]);

export const AllApplicableProductsInOrder: ApplicableProduct[] = [
  ProductClassification.ZipMoney,
  ProductClassification.ZipPay,
  ProductClassification.ZipPlus,
];
